/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actions from './ExternalCart-Actions';

const INITIAL_STATE = {
    error: {},
    list: [],
    deliveryMethodIds: {},
    accessToken: {},
};

const addExternalCartItemReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.setExternalCartError().type: {
            const { itemId, errors, featureType } = action.data;
            if (['cart', 'payment'].includes(featureType)) {
                return {
                    ...state,
                    error: {
                        ...state.error,
                        [featureType]: { ...errors },
                    },
                };
            }

            return {
                ...state,
                error: {
                    ...state.error,
                    [itemId]: { ...errors },
                },
            };
        }
        case actions.clearExternalCartItemsErrors().type: {
            const { itemId, featureType, clearData } = action.data || {};
            const newStateError = { ...state.error };

            if (
                itemId
                && featureType
                && (state[itemId] || state[featureType])
            ) {
                // Clean the full feature
                if (clearData.errType === 'clearAllFields' && newStateError[itemId][featureType]) {
                    if (['cart', 'payment'].includes(featureType)) {
                        newStateError[featureType] = {};
                    } else {
                        newStateError[itemId][featureType] = {};
                    }
                    return newStateError;
                }

                // Clean specific field in the feature type recipient/dtw
                if (clearData.field) {
                    if (!['cart', 'payment'].includes(featureType)) {
                        if (newStateError[itemId][featureType][clearData.field]) {
                            newStateError[itemId][featureType][clearData.field] = '';
                        }
                        if (newStateError[itemId][featureType].validationErrors) {
                            newStateError[itemId][featureType].validationErrors[clearData.field] = '';
                        }
                    }
                }

                return {
                    ...state,
                    error: newStateError,
                };
            }

            // Clear all the errors
            return {
                ...state,
                error: {},
            };
        }
        case actions.setExternalCartItems().type: {
            return {
                ...state,
                list: action.data,
            };
        }
        case actions.setExternalCartDTWById().type: {
            return {
                ...state,
                deliveryMethodIds: {
                    ...state.deliveryMethodIds,
                    ...action.data,
                },
            };
        }
        case actions.setExternalCartAccessToken().type: {
            return {
                ...state,
                accessToken: action.data,
            };
        }
        default:
            return state;
    }
};

export default addExternalCartItemReducer;
